import script from "./signup.vue?vue&type=script&setup=true&lang=ts"
export * from "./signup.vue?vue&type=script&setup=true&lang=ts"

import "./signup.vue?vue&type=style&index=0&id=352fe8ab&lang=scss&scoped=true"

import exportComponent from "/var/www/ShareMentors/ShareMentors/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352fe8ab"]])

export default __exports__